export default __webpack_public_path__ + "static/media/equal2.1dc50c71.png";